import { useRef, useEffect } from 'react';

export default function useDidUpdate(fn = () => {}, dependencies = []) {
  const hasRunOnce = useRef(false);
  const cacheFn = useRef(null);
  cacheFn.current = fn;

  /* eslint-disable */
  useEffect(() => {
    if (!hasRunOnce.current) {
      hasRunOnce.current = true;
      return;
    }

    return cacheFn.current();
  }, dependencies);
  /* eslint-enable */
}
